/*
 * @FilePath: router.config.js
 * @Author: Aron
 * @Date: 2023-07-21 11:29:16
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-09-18 19:10:07
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
 */
import operateConfig from "./operateConfig";
import financeConfig from "./financeConfig";
import operateManageConfig from "./operateManageConfig";
import dataCenter from "./dataCenter";
import cockpitManage from "./cockpitManage";
export const routes = [
  {
    path: "/",
    name: "login",
    component: () => import("@/views/Login/login"),
    meta: {
      permission: false,
      allowBack: false,
      noCache: true
    }
  },
  {
    path: "/ssologin",
    name: "ssologin",
    component: () => import("@/views/SsoLogin/index"),
    meta: {
      permission: false,
      allowBack: false,
      noCache: true
    }
  },
  {
    path: "/main",
    name: "home",
    component: () => import("@/views/Home/home"),
    meta: {
      permission: true,
      allowBack: false,
      noCache: true
    },
    children: [
      //运营中心
      ...operateConfig,
      //财务中心
      ...financeConfig,
      //运营管理
      ...operateManageConfig,
      // 数据中心
      ...dataCenter,
      // 驾驶舱
      ...cockpitManage,
      {
        path: "NoPermission",
        name: "NoPermission",
        meta: {
          title: "无权限"
        },
        component: () =>
          import("@/views/Home/NoPermission.vue")
      },
      {
        path: "NoMenu",
        name: "NoMenu",
        meta: {
          title: "无权限"
        },
        component: () =>
          import("@/views/Home/NoMenu.vue")
      },
      {
        path: "ExportImportQuery",
        name: "ExportImportQuery",
        meta: {
          title: "导出导入"
        },
        component: () =>import("@/views/Home/ExportImportQuery/index")
      },
    ]
  }
];
